
import AjaxCaller from "../../libs/ajax-caller/i96-ajax_caller.class.js";

class StagerNewsletter extends AjaxCaller {

    constructor(debug = false) {
        super('.logo-f-newsletter.spin-container', debug);

        addEventListener("DOMContentLoaded", (ev) => {
            this.initClickEvent();
        });

    }

    initClickEvent() {
        document.querySelector('.logo-f-newsletter .submit-button').addEventListener('click', () => {
            if (this.debug) console.log('StagerNewsletter: submit button click');
            this.submitButtonClick();
        });
    }

    async submitButtonClick() {
        if (this.debug) console.log('StagerNewsletter::logo_form_click');

        let errors = 0;
        const email = document.querySelector('.logo-f-newsletter .email-input ').value;
        const checkbox = document.querySelector('.logo-f-newsletter .terms-checkbox ').checked;

        if (this.debug) console.log('StagerNewsletter::logo_form_click' + ' > email = "' + email + '", checkbox = ' + ( checkbox ? 'true' : 'false'));

        // TERMS NOT ACCEPTED
        if (!checkbox) {
            //document.querySelector('.logo-f-newsletter .logo-f-legal label').classList.add('border-2', 'border-rose-500');
            document.querySelector('.logo-f-newsletter .terms-error').classList.remove('hidden');
            errors++;
        } else {
            //document.querySelector('.logo-f-newsletter .logo-f-legal label').classList.remove('border-2', 'border-rose-500');
            document.querySelector('.logo-f-newsletter .terms-error').classList.add('hidden');
        }

        // EMAIL ERROR
        if (email.length < 6) {
            this.setEmailError()
            errors++;
        } else {
            this.setEmailOk();
        }

        if (errors === 0) {

            if (this.debug) console.log('StagerNewsletter::logo_form_click > sending api post');

            const payload = {
                action: 'register_newsletter',
                nonce:  lewobat_ajax.nonce,
                email:  email
            }
            var result = await this.post( payload );

            // all good
            if (result.api_response && result.api_response === true) {
                document.querySelector('.logo-f-newsletter').classList.add('-sent');

            // something wrong with the email
            } else {
                if (result.api_response && result.api_response.email) {
                    this.setEmailError();
                }
            }

        }
    }

    /**
     * Highlights the email input field and shows the email error message
     */
    setEmailError() {
        document.querySelector('.logo-f-newsletter .email-wrapper').classList.add('border-2', 'border-[#A473DA]');
        document.querySelector('.logo-f-newsletter .email-error').classList.remove('hidden');
    }

    /**
     * Resets the style of the email input field and hides the email error message
     */
    setEmailOk() {
        document.querySelector('.logo-f-newsletter .email-wrapper').classList.remove('border-2', 'border-[#A473DA]');
        document.querySelector('.logo-f-newsletter .email-error').classList.add('hidden');
    }

}

export default StagerNewsletter;